import { Alert, Collapse } from "@mui/material";
import { useEffect, useState, useRef } from "react";

export default function AlertTimer(props) {
  const { open, handleAlertTimerClose, text, callback } = props;
  const [value, setValue] = useState(0);
  const alertRef = useRef();

  useEffect(() => {
    if (open) {
      setValue(2);
      alertRef.current.style.bottom = "44vh";
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        if (value == 1) {
          handleAlertTimerClose();
        }
        setValue(value - 1);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [value]);

  return (
    <Collapse in={open}>
      <Alert icon={false} className="toast fixed" id="alertRef" ref={alertRef}>
        {text}
      </Alert>
    </Collapse>
  );
}
